module.exports = __webpack_public_path__ + "static/media/chandizhengshenqingliucheng6.257e8acb.png";